var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#0E0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20586 5.17773L9.90097 11.4554L5.17627 16.5595H6.23969L10.3763 12.0907L13.7184 16.5595H17.337L12.3776 9.92876L16.7754 5.17773H15.7119L11.9025 9.29328L8.82448 5.17773H5.20586ZM6.76967 5.96097H8.43205L15.773 15.7763H14.1106L6.76967 5.96097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.bcfefaa56ccce5f462f87693f36a6132.svg";
export { ForwardRef as ReactComponent };